export const getProductURL = (
  productSlug: string,
  variantSku?: string,
  deviceName?: string
) =>
  variantSku && deviceName
    ? `/products/${productSlug}/?variant=${variantSku}&device=${deviceName.replace(
        / /g,
        "+"
      )}`
    : variantSku
      ? `/products/${productSlug}/?variant=${variantSku}`
      : `/products/${productSlug}/`

export const getShopURL = () => `/collections/all/`

export const getShopURLForSeriesDeviceType = (seriesSlug, deviceType) =>
  `/collections/${seriesSlug}-series-${deviceType}/`

export const getShopURLForDevice = (deviceSlug) => `/collections/${deviceSlug}/`

export const getShopURLForDeviceType = (deviceTypeSlug) =>
  `/collections/${deviceTypeSlug}/`

export const getShopURLForBrandDeviceType = (brandSlug, deviceTypeSlug) =>
  `/collections/${brandSlug}-${deviceTypeSlug}/`

export const getExploreEntryURL = (entryTypeSlug, entrySlug) =>
  `/${entryTypeSlug}/${entrySlug}/`
